// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import correspondenceEntity from './entities/correspondence.json';
import correspondenceMenu from '../pages/correspondence/menu.json';
import correspondenceFullForm from '../pages/correspondence/forms/full.json';
import correspondenceContextForm from '../pages/correspondence/forms/context.json';
import correspondenceMiniForm from '../pages/correspondence/forms/mini.json';
import correspondenceLookupForm from '../pages/correspondence/forms/lookup.json';
import correspondenceTableView from '../pages/correspondence/views/table.json';
import correspondenceStagesView from '../pages/correspondence/views/stages.json';
import correspondenceCardsView from '../pages/correspondence/views/cards.json';
import correspondenceInlineView from '../pages/correspondence/views/inline.json';
import correspondenceBacklogView from '../pages/correspondence/views/backlog.json';
import correspondenceSplitView from '../pages/correspondence/views/split.json';
import correspondenceCalendarView from '../pages/correspondence/views/calendar.json';
import correspondenceDashboardView from '../pages/correspondence/views/dashboard.json';

/** Тип запису «Лист» зі сторінками пакета: меню, форми та подання з pages/correspondence/. */
export const correspondenceDefinition: IRecordTypeDefinition = {
  ...correspondenceEntity,
  views: assembleViewSet({
      table: correspondenceTableView,
      stages: correspondenceStagesView,
      cards: correspondenceCardsView,
      inline: correspondenceInlineView,
      backlog: correspondenceBacklogView,
      split: correspondenceSplitView,
      calendar: correspondenceCalendarView,
      dashboard: correspondenceDashboardView,
  }),
  form: correspondenceFullForm,
  forms: { full: correspondenceFullForm, context: correspondenceContextForm, mini: correspondenceMiniForm, lookup: correspondenceLookupForm },
  menu: correspondenceMenu,
} as IRecordTypeDefinition;
